import React from 'react';
import {
  TableCell,
  TableRow,
  TableHead,
}            from '@material-ui/core';
import {
  IDataTableHeader,
}            from '@typings/components';

interface IProps {
  title?   : string;
  headers? : IDataTableHeader[];
}

export const DataTableHead: React.FC<IProps> = ({
  title,
  headers,
}: IProps): JSX.Element => (
  <TableHead>
    {title && (
      <TableRow>
        <h1>{title}</h1>
      </TableRow>
    )}

    {headers && (
      <TableRow>
        {headers.map(
          (header: IDataTableHeader, headerIndex: number): JSX.Element => (
            <TableCell
              component = "th"
              scope     = "row"
              align     = {header.align ?? 'left'}
              key       = {headerIndex}
              style     = {{
                width: header.width ?? 'auto',
              }}
            >
              {header.label}
            </TableCell>
          ),
        )}
      </TableRow>
    )}
  </TableHead>
);
